import './global-script'
import { setPremission } from '@/router/router-permission'
// import { loadConfig } from '@/utils/request/config'
import { str } from "./language/Strings"
import { createApp } from 'vue'
import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayOfYear from 'dayjs/plugin/dayOfYear'
import 'dayjs/locale/zh-cn'
import element from './element'
import vuetify from './vuetify'
import notify from '@/plugins/notification/index'
import store from './store'
import router from './router'
import directive from './directive'
import eCharts from './plugins/eCharts'
import eventTracking from '@/plugins/eventTracking/index'
import components from './components'
import App from './App.vue'
// import { ws_req } from '@/ws/wss-request'

// 导入全局样式
import '@/styles/index.scss'
import 'ems-ui/eui.css'

// 导入并注册 v-viewer
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

dayjs.extend(localeData)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(dayOfYear)
dayjs.locale('zh-cn')



/**
 * 初始化并启动应用
 */
async function initApp() {
  const app = createApp(App)

  // 注册插件
  app.use(element)
  app.use(vuetify)
  app.use(store)
  app.use(directive)
  app.use(notify)
  app.use(str)
  app.use(eCharts)
  app.use(VueViewer)
  app.use(router)
  app.use(components) // 注册全局组件

  // 注册埋点插件
  app.use(eventTracking, { router })

  // 设置路由权限（需要在store初始化之后调用）
  setPremission(router)

  // 挂载应用
  app.mount('#root')

  if (process.env.NODE_ENV === 'development') {
    console.log('应用已成功启动')
  }
}

// 启动应用
initApp().catch(error => {
  console.error('致命错误：应用无法启动', error)
})


